<template>
    <div class="page">
        <!-- 搜索 -->
        <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
            <el-form-item label="参团用户ID">
<!--                <el-input  v-model="queryForm.buyUserId"></el-input>-->
                <GridSelectU style="width: 177px;" labelName="userName"
                             labelValue="id" :value="queryForm.buyUserId" :limit='1' size='small' placeholder='请选择用户'
                             @getValue="getSearchUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                </GridSelectU>
            </el-form-item>
            <el-form-item label="订单ID">
                <el-input  v-model="queryForm.orderId"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="getShopProductGroupbuyGroupRecordList">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group">
<!--                    <el-button-->
<!--                        type="primary"-->
<!--                        size="small"-->
<!--                        icon="el-icon-plus"-->
<!--                        @click="addShopProductGroupbuyGroupRecord"-->
<!--                    >新建</el-button>-->
<!--                    <el-button-->
<!--                        type="warning"-->
<!--                        plain-->
<!--                        size="small"-->
<!--                        icon="el-icon-edit"-->
<!--                        :disabled="multipleSelection.length != 1"-->
<!--                        @click="editShopProductGroupbuyGroupRecord(null)"-->
<!--                    >修改</el-button>-->
<!--                    <el-button-->
<!--                        type="danger"-->
<!--                        plain-->
<!--                        size="small"-->
<!--                        icon="el-icon-delete"-->
<!--                        :disabled="multipleSelection.length <= 0"-->
<!--                        @click="deleteShopProductGroupbuyGroupRecord(null)"-->
<!--                    >删除</el-button>-->
                </div>

                <div class="icon-group">
                    <el-upload v-if="this.isImportDate"
                               class="upload-demo"
                               action="#"
                               :http-request="upload"
                               :show-file-list="true">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
                    </el-upload>
                    <span
                        title="搜索"
                        class="icon-box"
                        @click="search"
                    >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
                    <span
                        title="下载模板"
                        class="icon-box"
                        @click="importTemplate"
                    >
          <Icon color="#606266">
            <ArrowDown />
          </Icon>
        </span>
                    <span
                        class="icon-box"
                        title="导入数据"
                        @click="isImport"
                    >
          <Icon color="#606266">
            <ArrowExportUp24Regular />
          </Icon>
        </span>
                    <span
                        title="导出数据"
                        class="icon-box"
                        @click="exportShopProductGroupbuyGroupRecordList"
                    >
          <Icon color="#606266">
            <ArrowDownload24Regular />
          </Icon>
        </span>
                    <span
                        class="icon-box"
                        @click="refreshShopProductGroupbuyGroupRecordList"
                    >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table
                :data="shopProductGroupbuyGroupRecordList"
                row-key="id"
                border
                height="100%"
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                @selection-change="handleSelectionChange"
                size="small"
            >
                <el-table-column
                    align="center"
                    type="selection"
                    width="60"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="buyUserId"
                    label="参团用户ID"
                    width="180"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="orderId"
                    label="订单ID"
                    width="180"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="createTime"
                    label="创建时间"
                    width="180"
                > </el-table-column>
                <el-table-column
                    fixed="right"
                    align="center"
                    label="操作"
                    width="300"
                >
                    <template slot-scope="scop">
                        <div class="operation">
                            <div @click="checkShopProductGroupbuyGroupRecord(scop.row.id)">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span class="operation-label">查看</span>
                            </div>
<!--                            <div @click="editShopProductGroupbuyGroupRecord(scop.row.id)">-->
<!--                                <Icon size="16">-->
<!--                                    <Edit24Regular />-->
<!--                                </Icon>-->
<!--                                <span class="operation-label">修改</span>-->
<!--                            </div>-->
<!--                            <div @click="deleteShopProductGroupbuyGroupRecord(scop.row.id)">-->
<!--                                <Icon size="16" style="color: red">-->
<!--                                    <Delete24Regular />-->
<!--                                </Icon>-->
<!--                                <span class="operation-label" style="color: red">删除</span>-->
<!--                            </div>-->
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog
                :title="shopProductGroupbuyGroupRecordStates[shopProductGroupbuyGroupRecordState]"
                :visible.sync="showDialog"
                width="60%"
                :modal="false"
                @close="closeDialog"
            >
                <div>
                    <el-form
                        :model="shopProductGroupbuyGroupRecord"
                        ref="shopProductGroupbuyGroupRecordForm"
                        :rules="rules"
                        label-width="120px"
                        :inline="true"
                        size="small"
                    >
                        <el-form-item
                            label="参团用户ID"
                            prop="buyUserId"
                        >
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                v-model="shopProductGroupbuyGroupRecord.buyUserId"-->
<!--                                :disabled="shopProductGroupbuyGroupRecordState == 'check'"-->
<!--                            ></el-input>-->
                            <GridSelectU style="width: 177px;" labelName="userName" :disabled="shopProductGroupbuyGroupRecordState == 'check'"
                                         labelValue="id" :value="shopProductGroupbuyGroupRecord.buyUserId" :limit='1' size='small' placeholder='请选择用户'
                                         @getValue="getSearchUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                            </GridSelectU>
                        </el-form-item>
                        <el-form-item
                            label="订单ID"
                            prop="orderId"
                        >
                            <el-input
                                size="small"
                                v-model="shopProductGroupbuyGroupRecord.orderId"
                                :disabled="shopProductGroupbuyGroupRecordState == 'check'"
                            ></el-input>
                        </el-form-item>
                    </el-form>
                </div>

                <div
                    slot="footer"
                    class="flex justify-end"
                >
                    <el-button @click="closeDialog">关闭</el-button>
                    <el-button
                        type="primary"
                        @click="submitForm"
                        v-if="shopProductGroupbuyGroupRecordState != 'check'"
                    >确定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect/index.vue';
import { USER, USER_SEARCH } from '@/utils/constant';

export default {
    components: {
        GridSelectU,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetShopProductGroupbuyGroupRecordList();
                this.getShopProductGroupbuyGroupRecordList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetShopProductGroupbuyGroupRecordList();
                this.getShopProductGroupbuyGroupRecordList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            USER_code: USER,
            USER_search: USER_SEARCH,
            queryForm:{
                groupId: '', //团ID
                buyUserId: '', //参团用户ID
                orderId: '', //订单ID
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            shopProductGroupbuyGroupRecordState: 'add',
            shopProductGroupbuyGroupRecordStates: {
                add: '新建团员详情',
                check: '查看团员详情',
                edit: '修改团员详情'
            },

            multipleSelection: [],
            shopProductGroupbuyGroupRecordList: [],
            shopProductGroupbuyGroupRecord: {
                id: '', //ID
                groupId: '', //团ID
                buyUserId: '', //参团用户ID
                orderId: '', //订单ID
            },
            btnLoading: false,

            rules: {
                groupId: [{ required: true, message: '团ID不能为空', trigger: 'blur' }],
                buyUserId: [{ required: true, message: '参团用户ID不能为空', trigger: 'blur' }],
                orderId: [{ required: true, message: '订单ID不能为空', trigger: 'blur' }],
            }
        };
    },
    created() {
        // this.getShopProductGroupbuyGroupRecordList();
    },
    methods: {
        getValueUser(value) {
            this.shopProductGroupbuyGroupRecord.buyUserId = value
        },
        getSearchUser(value){
            this.queryForm.buyUserId = value;
        },
        show(id){
            this.queryForm.groupId = id;
            this.resetShopProductGroupbuyGroupRecordList()
            this.getShopProductGroupbuyGroupRecordList()
        },
        search(){
            this.isSearch = !this.isSearch;
        },
        resetShopProductGroupbuyGroupRecordList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.shopProductGroupbuyGroupRecordList = [];
        },
        resetDialog() {
            this.shopProductGroupbuyGroupRecordState = 'add';
            this.showDialog = false;
            this.queryForm = {
                groupId: '', //团ID
                buyUserId: '', //参团用户ID
                orderId: '', //订单ID
            };
            this.getShopProductGroupbuyGroupRecordList();
        },
        closeDialog() {
            this.showDialog = false
            this.shopProductGroupbuyGroupRecord = {
                id: '', //ID
                groupId: '', //团ID
                buyUserId: '', //参团用户ID
                orderId: '', //订单ID
            };
        },
        submitForm() {
            if (this.shopProductGroupbuyGroupRecordState == 'add') {
                this.$refs.shopProductGroupbuyGroupRecordForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/shop/productgroupbuygrouprecord/add`,{ ...this.shopProductGroupbuyGroupRecord }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000,
                                });
                                this.resetShopProductGroupbuyGroupRecordList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            } else if (this.shopProductGroupbuyGroupRecordState == 'edit') {
                this.$refs.shopProductGroupbuyGroupRecordForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/shop/productgroupbuygrouprecord/edit`,{ ...this.shopProductGroupbuyGroupRecord }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopProductGroupbuyGroupRecordList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            }
        },
        addShopProductGroupbuyGroupRecord() {
            this.showDialog = true;
            this.shopProductGroupbuyGroupRecordState = 'add';
        },
        checkShopProductGroupbuyGroupRecord(shopProductGroupbuyGroupRecordId) {
            console.log(shopProductGroupbuyGroupRecordId);
            this.currentShopProductGroupbuyGroupRecordId = shopProductGroupbuyGroupRecordId;

            this.getShopProductGroupbuyGroupRecordById();
            this.showDialog = true;
            this.shopProductGroupbuyGroupRecordState = 'check';
        },
        editShopProductGroupbuyGroupRecord(shopProductGroupbuyGroupRecordId) {
            console.log('shopProductGroupbuyGroupRecord', shopProductGroupbuyGroupRecordId);
            if (shopProductGroupbuyGroupRecordId) {
                this.currentShopProductGroupbuyGroupRecordId = shopProductGroupbuyGroupRecordId;
                this.getShopProductGroupbuyGroupRecordById();
            } else {
                this.shopProductGroupbuyGroupRecord = { ...this.shopProductGroupbuyGroupRecord, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.shopProductGroupbuyGroupRecordState = 'edit';
        },
        deleteShopProductGroupbuyGroupRecord(shopProductGroupbuyGroupRecordId) {
            let ids = '';
            if (shopProductGroupbuyGroupRecordId) {
                ids = shopProductGroupbuyGroupRecordId;
            } else {
                ids = this.multipleSelection.map((shopProductGroupbuyGroupRecord) => shopProductGroupbuyGroupRecord.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/shop/productgroupbuygrouprecord/delete`,{ ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetShopProductGroupbuyGroupRecordList();
                            this.getShopProductGroupbuyGroupRecordList();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                })
                .catch(() => {});
        },
        refreshShopProductGroupbuyGroupRecordList() {
            this.resetShopProductGroupbuyGroupRecordList();
            this.getShopProductGroupbuyGroupRecordList();
        },
        getShopProductGroupbuyGroupRecordList(query = {}) {
            this.loading = true;
            get(`/shop/productgroupbuygrouprecord/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.shopProductGroupbuyGroupRecordList = res.page.list;
                    this.totalNum = res.page.total;
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        getShopProductGroupbuyGroupRecordById() {
            get(`/shop/productgroupbuygrouprecord/get`,{ id: this.currentShopProductGroupbuyGroupRecordId }).then((res) =>{
                if(res.success){
                    this.shopProductGroupbuyGroupRecord = { ...this.shopProductGroupbuyGroupRecord, ...res.shopProductGroupbuyGroupRecord };
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        /**
         * 导出信息
         */
        exportShopProductGroupbuyGroupRecordList() {
            //this.btnLoading = true;
            exprotExcel(`/shop/productgroupbuygrouprecord/export`, {...this.queryForm});
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/shop/productgroupbuygrouprecord/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params){
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/shop/productgroupbuygrouprecord/importData`,formData);
            this.refreshShopProductGroupbuyGroupRecordList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getShopProductGroupbuyGroupRecordList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getShopProductGroupbuyGroupRecordList();
        }
    }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>